import React from "react";
import ExploreTechnologyBanner from "./ExploreTechnologyBanner";
import "./ExploreTechnology.css";
// Main component for Explore Apps
export default function ExploreTechnology() {
  return (
    <>
        {/* Banner */}
        <ExploreTechnologyBanner />
    </>
  );
}
